import IEventBinding from './Interfaces/IEventBinding';
import Player        from './Player';

import bindExitFullscreenEvent from './Events/bindExitFullscreenEvent';
import bindRootBlurEvent       from './Events/bindRootBlurEvent';
import bindRootClickEvent      from './Events/bindRootClickEvent';
import bindRootFocusEvent      from './Events/bindRootFocusEvent';
import bindRootMouseEnterEvent from './Events/bindRootMouseEnterEvent';
import bindRootMouseLeaveEvent from './Events/bindRootMouseLeaveEvent';
import bindRootMouseMoveEvent  from './Events/bindRootMouseMoveEvent';

const connectGlobalEvents = (player: Player): IEventBinding[] => [
    bindExitFullscreenEvent(),
    bindRootFocusEvent(player),
    bindRootBlurEvent(player),
    bindRootClickEvent(player),
    bindRootMouseEnterEvent(player),
    bindRootMouseLeaveEvent(player),
    bindRootMouseMoveEvent(player)
];

export default connectGlobalEvents;